import React, { useEffect, useState } from "react";

export default function GatewayQrCode({ value, size = 196, label = "Authenticator enrollment QR code" }) {
  const [dataUrl, setDataUrl] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    setDataUrl("");
    setError("");

    if (!value) return () => { active = false; };

    import("qrcode")
      .then(({ toDataURL }) => toDataURL(value, {
        errorCorrectionLevel: "M",
        margin: 2,
        width: size,
        color: { dark: "#071019", light: "#ffffff" },
      }))
      .then((url) => { if (active) setDataUrl(url); })
      .catch(() => { if (active) setError("QR code could not be rendered. Use the setup key below."); });

    return () => { active = false; };
  }, [size, value]);

  if (!value) return null;

  return (
    <div className="gatewayQr" aria-live="polite">
      {dataUrl ? <img src={dataUrl} width={size} height={size} alt={label} /> : <div className="gatewayQr__loading">Preparing QR code…</div>}
      {error ? <p className="gatewayQr__error">{error}</p> : null}
    </div>
  );
}
